import { Component } from '@angular/core';
import {dayjs} from '@karve.it/core';

import { transactionVolumeChartOptions } from '../../dashboard/dashboard.constants';
import { DashboardStore } from '../dashboardv2.store';

@Component({
  selector: 'app-activity',
  templateUrl: './activity.component.html',
  styleUrls: [
    '../dashboardv2.component.scss',
    './activity.component.scss',
  ],
})
export class ActivityComponent {

  activity$ = this.dashboardStore.select(
    this.dashboardStore.activityViewModel$,
    (activity) => {

      const transactionsPaidMap = this.toMap(activity.transactionsHappeningPerDay);

      const eventsCreatedMap = this.toMap(activity.eventsCreatedPerDay);

      const eventsHappeningMap = this.toMap(activity.eventsHappeningPerDay);

      const dates = [];

      const labels = [];

      const transactionsPaidData = [];

      const eventsCreatedData = [];

      const eventsHappeningData = [];

      let current = activity.period.start;

      while (current <= activity.period.end) {
        const day = dayjs(current * 1000);
        dates.push(day.format('YYYY-MM-DD'));
        if (activity.isMonthMode) {
          labels.push(day.format('DD'));
        } else {
          labels.push(day.format('YYYY-MM-DD'));
        }
        current = day.add(1, 'day').unix();
      }

      let transactionsPaidCumulative = 0;
      let eventsCreatedCumulative = 0;
      let eventsHappeningCumulative = 0;

      for (const date of dates) {

        eventsHappeningCumulative += eventsHappeningMap[date] || 0;
        eventsHappeningData.push(eventsHappeningCumulative);

        transactionsPaidCumulative += transactionsPaidMap[date] || 0;
        transactionsPaidData.push(transactionsPaidCumulative);

        eventsCreatedCumulative += eventsCreatedMap[date] || 0;
        eventsCreatedData.push(eventsCreatedCumulative);
      }

      const documentStyle = getComputedStyle(document.documentElement);

      return {
        ...activity,
        options: transactionVolumeChartOptions,
        graphData: {
          labels,
          datasets: [
            {
              label: "Transactions paid",
              data: transactionsPaidData,
              borderColor: [
                documentStyle.getPropertyValue('--primary-color'),
              ],
              borderWidth: 3,
            },
            {
              label: 'Created events',
              data: eventsCreatedData,
              borderColor: [
                documentStyle.getPropertyValue('--orange-500'),
              ],
              borderWidth: 3,
            },
            {
              label: 'Scheduled events',
              data: eventsHappeningData,
              borderColor: [
                documentStyle.getPropertyValue('--info'),
              ],
              borderWidth: 3,
            },
          ],
        },
      }
    },
  );

  constructor(
    private readonly dashboardStore: DashboardStore,
  ) {}

  toMap(tupleArray: string[][]) {

    const output = {};

    for (const [ date, amount ] of tupleArray) {
      output[date] = output[date] || 0;
      output[date] += parseFloat(amount);
    }

    return output;
  }

}
